<template lang="pug">
  div.locked-mask
    div.mask-message
      h5 目前前台登入中的使用者
      hr
      div.text-center(v-for="user in loginedUsers") 
        span {{ user.username }} 
        span(v-if="user.first_name || user.last_name") ({{user.last_name}} {{user.first_name}})
      hr
      p.text-center 請等待前台操作完畢
</template>

<script>
export default {
  name: 'LockedMask',
  computed: {
    loginedUsers() {
      return this.$store.getters.loginedUsers;
    },
  },
};
</script>

<style lang="sass">
.locked-mask
  // background: rgba(0,0,0,0.2);
  width: calc(100% - 32px);
  margin: 0 -15px;
  height: 100%;
  z-index: 900;
  position: absolute;
  display: flex
  align-items: center
  justify-content: center
  .mask-message
    background: rgba(255,255,255,0.9)
    padding: 15px
    border-radius: 10px
    background: #42b883
    color: white
  hr
    background: white
    margin: 3px
  p
    margin: 0px
</style>




// WEBPACK FOOTER //
// LockedMask.vue?57408461